// api.js

import axiosInstance from '../axiosInstance'

export const shippingServiceMapService = {
  create: async (serviceData) => {
    try {
      let response = await axiosInstance.post('/shipping-service-map', {
        ...serviceData
      })
      return response.data
    } catch (error) {
      throw error
    }
  },

  fetch: async (limit, skip, clientId, searchValue) => {
    try {
      let response = await axiosInstance.get(
        `/shipping-service-map?$limit=${limit || 15}&$skip=${skip || 0}&${
          clientId ? `client_id=${clientId}` : ''
        }&$populate=client_id&$populate=shipping_service`
      )
      return response.data
    } catch (error) {
      throw error
    }
  },
  fetchShippingService: async (limit, skip, clientId, searchValue) => {
    try {
      let response = await axiosInstance.get(`/shipping-service?$limit=${limit || 50}&$skip=${skip || 0}`)
      return response.data
    } catch (error) {
      throw error
    }
  },
  edit: async (serviceData, id) => {
    try {
      let response = await axiosInstance.patch(`/shipping-service-map/${id}`, {
        ...serviceData
      })
      return response.data
    } catch (error) {
      throw error
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/shipping-service-map/${id}`)
      return response.data
    } catch (error) {
      throw error
    }
  }
}
